export default __webpack_public_path__ + "8ac9022ab829d474fdec4fbf60cd8a99.png";